import Mention from "@tiptap/extension-mention";
import { Range } from "@tiptap/react";
import { makeInsertFn } from "./makeInsertFn";

declare module "@tiptap/core" {
  // eslint-disable-next-line unused-imports/no-unused-vars
  interface Commands<ReturnType> {
    mentionVar: {
      insertVar: (text: string, range?: Range) => ReturnType;
    };
  }
}

const START_REGEX = /^{{(\s)?/g;
const END_REGEX = /(\s)?}}$/g;

export const MentionVarBase = Mention.extend({
  name: "mention-var",
  addCommands() {
    return {
      insertVar: makeInsertFn(this.type, START_REGEX, END_REGEX),
    };
  },
});
